import { createSelector } from 'reselect'

import { FETCH_STATUSES } from 'resources'
import getDecimalValue from 'utils/get-decimal-value'

import { POPULAR_CATEGORY } from './constants'

export const getIsFetchingRewards = ({ rewards }) => rewards?.status === FETCH_STATUSES.FETCHING

export const getRewards = ({ rewards }) => rewards?.rewards || []

const getCategoriesRaw = ({ rewards }) => rewards?.categories || []

export const getCategories = createSelector([getCategoriesRaw, getRewards], (categories, rewards) =>
  categories.filter((category) =>
    rewards.some((reward) => (category.id === POPULAR_CATEGORY ? reward.isTop : reward.categoryId === category.id)),
  ),
)

export const getCurrency = ({ rewards }) => rewards?.currency || ''

export const getGoalReward = ({ rewards }) => rewards?.goal?.reward || null

export const getGoalAmount = ({ rewards }) => getDecimalValue(rewards?.goal?.amount || 0)

export default {
  getIsFetchingRewards,
  getCategories,
  getRewards,
  getCurrency,
  getGoalReward,
  getGoalAmount,
}
